
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Popup from 'vux/src/components/popup/index.vue'

import { getCertificate } from "../../common/js/api.js";
import { getCookie, setCookie, removeCookie } from "../../common/js/utils";
import router from "@/router/index.js";

export default {
directives: {
TransferDom
},
components: {
Box,
XButton,
XInput,
Group,
TransferDom,
XDialog,
Popup
},
data() {
return {
showNew: false,
entity: {}
};
},
methods: {
hideMask() {
this.showNew = false;
}
},
beforeCreate: function() {
document
.getElementsByTagName("body")[0]
.setAttribute("class", "certificateBody");
},
beforeDestroy: function() {
console.log("beforeDestroy");
document
.getElementsByTagName("body")[0]
.removeAttribute("class", "certificateBody");
},
activated() {
let self = this;
this.isNew = this.$route.query.isNew;
if (this.isNew) {
this.showNew = true;
}
this.orderId = this.$route.query.orderId;
getCertificate({ orderId: this.orderId }).then(function(data) {
self.entity = data.Content;
});
}
};



// WEBPACK FOOTER //
// ./src/components/usercenter/Certificate.vue